// pages/portal/billing-usage.tsx
import PortalRedirect from '../../components/portal/layout/portal-redirect.component';

/**
 * Legacy route — redirects to /portal/usage per Phase 3 IA.
 * Kept for at least 30 days after Phase 6 flag flip; delete after.
 */
export default function BillingUsageRedirect() {
    return <PortalRedirect to="/portal/usage" />;
}
